      <app-cc-table body #ccTable [transPartKey]="transPartKey"
                    [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
                    [contextMenuConfig]="contextMenuConfig" [(selectedRecord)]="formRecord"
                    [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading" [currentRequest]="tableCurrentRequest"
                    (loadRecordsEvent)="needLoadRecords($event)"
                    [fieldName]="'id'" [fieldId]="'id'"
                    [disableContextMenu]="true" [disableSelection]="true"
                    [defaultSortField]="'creationDate'" [defaultSortOrder]="1"
                    >
      </app-cc-table>

<app-cc-detail-dialog [formConfig]="formConfig" [transPartKey]="transPartKey"
  [formRecord]="selectedProfile" [(dialogFormVisible)]="detailDialogVisible">
</app-cc-detail-dialog>
